<template>
  <div class="form__loader" :class="{ 'form__loader--loading': isLoading }">
    <div>
      <span class="loader__text">{{ loadingText }}</span>
    </div>
  </div>
</template>

<script>
import store from '../store';

export default {
  computed: {
    isLoading() {
      return store.state.isLoading || store.state.isLoadingBestRoof;
    },
    loadingText() {
      return store.state.loadingText;
    },
  },
};
</script>

<style scoped>
.loader__text {
  width: 10rem;
}
</style>
